// @ts-nocheck
import { Button, Input, message } from "antd";
import axios from "axios";
import React, { useState } from "react";
import API_HOST from "../config.js";
import { DollarOutlined} from '@ant-design/icons';
const { TextArea } = Input;

function LoadMccFunction(props) {
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const load = async (profile) => {
    let body = {
      profile: profile,
    };
    axios
      .post(`${API_HOST}/api/account/load-mcc`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ account/load-mcc ~ e:", e);
        messageApi.error(e.response.data);
      });
  };
  return (
    <>
      {contextHolder}
      <Button loading={loading} onClick={() => load(props.profile)}>
        <DollarOutlined /> 
        Tải MCC
      </Button>
    </>
  );
}
export default LoadMccFunction;
